<div class="recents-wrapper w-100 h-100 d-flex flex-column align-items-center overflow-auto overflow-x">
  <div class="recents-wrapper-content w-100">
    <div
      class="font-size-header text-white font-weight-bold w-100 d-flex flex-column align-items-center justify-content-end mt-5 mb-3 primary-brand-background-color py-4">
      <span>{{ 'public.global.recents' | translate}}</span>
    </div>
    <div class="recents-content d-flex flex-column align-items-center justify-content-center w-100">
      <div *ngIf="storeRecentsList.length === 0"
        class="d-flex flex-column align-items-center justify-content-center m-2 col-12">
        <div class="nothing-found d-flex flex-column flex-wrap align-items-center justify-content-center col-9">
          <i class="fa-solid fa-basket-shopping mx-auto my-5 fs-80"></i>
          <div class="py-3 font-size-primary description text-center">
            {{'public.recents.nothingFound' | translate}}
          </div>
        </div>
      </div>
      <div class="d-flex flex-column justify-content-start m-2 col-12 overflow-auto overflow-x px-4">
        <ng-container *ngFor="let storeRecentsInfo of storeRecentsList">
          <div class="d-flex flex-row align-items-center justify-content-start my-2"
            (click)="onClickStore(storeRecentsInfo.storeAlias)">
            <div class="store-logo mr-2">
              <img *ngIf="storeRecentsInfo.storeLogoUrl" [src]="storeRecentsInfo.storeLogoUrl" />
              <img *ngIf="!storeRecentsInfo.storeLogoUrl" src="assets/img/store-grey.png" />
            </div>
            <div class="w-100 text-truncate">
              <div class="font-size-primary">{{ storeRecentsInfo.storeName.toUpperCase() }}</div>
              <div class="font-size-secondary text-truncate">{{ storeRecentsInfo.storeUrl }}</div>
            </div>
          </div>
          <hr class="secondary-brand-background-color">
        </ng-container>
      </div>
    </div>
  </div>
</div>
